module.exports = __webpack_public_path__ + "static/media/CTLI_2-293w.02dfa1c6.png";